module.exports = __webpack_public_path__ + "static/video-thumb-489397b63d4db4e3b0ec8c810c44ffb0.png";